/*
 * Каталог обложек Comabooks (24 пресета = 4 группы вёрстки × 6 цветов).
 * Зеркало backend/src/data/comabooksCovers.ts — id должны совпадать.
 * preview — картинка-превью старого клиента (S3 *.png, перекодировано в webp),
 * thumb   — кнопка селектора старого клиента (option<G>cover<N>button.png).
 */

import g1black from '../../assets/comabooks-covers/cb-1-black.webp';
import g1blackThumb from '../../assets/comabooks-covers/thumbs/cb-1-black.webp';
import g1blue from '../../assets/comabooks-covers/cb-1-blue.webp';
import g1blueThumb from '../../assets/comabooks-covers/thumbs/cb-1-blue.webp';
import g1green from '../../assets/comabooks-covers/cb-1-green.webp';
import g1greenThumb from '../../assets/comabooks-covers/thumbs/cb-1-green.webp';
import g1lightgreen from '../../assets/comabooks-covers/cb-1-lightgreen.webp';
import g1lightgreenThumb from '../../assets/comabooks-covers/thumbs/cb-1-lightgreen.webp';
import g1red from '../../assets/comabooks-covers/cb-1-red.webp';
import g1redThumb from '../../assets/comabooks-covers/thumbs/cb-1-red.webp';
import g1brown from '../../assets/comabooks-covers/cb-1-brown.webp';
import g1brownThumb from '../../assets/comabooks-covers/thumbs/cb-1-brown.webp';
import g2black from '../../assets/comabooks-covers/cb-2-black.webp';
import g2blackThumb from '../../assets/comabooks-covers/thumbs/cb-2-black.webp';
import g2blue from '../../assets/comabooks-covers/cb-2-blue.webp';
import g2blueThumb from '../../assets/comabooks-covers/thumbs/cb-2-blue.webp';
import g2green from '../../assets/comabooks-covers/cb-2-green.webp';
import g2greenThumb from '../../assets/comabooks-covers/thumbs/cb-2-green.webp';
import g2lightgreen from '../../assets/comabooks-covers/cb-2-lightgreen.webp';
import g2lightgreenThumb from '../../assets/comabooks-covers/thumbs/cb-2-lightgreen.webp';
import g2red from '../../assets/comabooks-covers/cb-2-red.webp';
import g2redThumb from '../../assets/comabooks-covers/thumbs/cb-2-red.webp';
import g2brown from '../../assets/comabooks-covers/cb-2-brown.webp';
import g2brownThumb from '../../assets/comabooks-covers/thumbs/cb-2-brown.webp';
import g3black from '../../assets/comabooks-covers/cb-3-black.webp';
import g3blackThumb from '../../assets/comabooks-covers/thumbs/cb-3-black.webp';
import g3blue from '../../assets/comabooks-covers/cb-3-blue.webp';
import g3blueThumb from '../../assets/comabooks-covers/thumbs/cb-3-blue.webp';
import g3green from '../../assets/comabooks-covers/cb-3-green.webp';
import g3greenThumb from '../../assets/comabooks-covers/thumbs/cb-3-green.webp';
import g3lightgreen from '../../assets/comabooks-covers/cb-3-lightgreen.webp';
import g3lightgreenThumb from '../../assets/comabooks-covers/thumbs/cb-3-lightgreen.webp';
import g3red from '../../assets/comabooks-covers/cb-3-red.webp';
import g3redThumb from '../../assets/comabooks-covers/thumbs/cb-3-red.webp';
import g3brown from '../../assets/comabooks-covers/cb-3-brown.webp';
import g3brownThumb from '../../assets/comabooks-covers/thumbs/cb-3-brown.webp';
import g4black from '../../assets/comabooks-covers/cb-4-black.webp';
import g4blackThumb from '../../assets/comabooks-covers/thumbs/cb-4-black.webp';
import g4blue from '../../assets/comabooks-covers/cb-4-blue.webp';
import g4blueThumb from '../../assets/comabooks-covers/thumbs/cb-4-blue.webp';
import g4green from '../../assets/comabooks-covers/cb-4-green.webp';
import g4greenThumb from '../../assets/comabooks-covers/thumbs/cb-4-green.webp';
import g4lightgreen from '../../assets/comabooks-covers/cb-4-lightgreen.webp';
import g4lightgreenThumb from '../../assets/comabooks-covers/thumbs/cb-4-lightgreen.webp';
import g4red from '../../assets/comabooks-covers/cb-4-red.webp';
import g4redThumb from '../../assets/comabooks-covers/thumbs/cb-4-red.webp';
import g4brown from '../../assets/comabooks-covers/cb-4-brown.webp';
import g4brownThumb from '../../assets/comabooks-covers/thumbs/cb-4-brown.webp';

export type ComabooksCoverGroup = 1 | 2 | 3 | 4;

export interface ComabooksCoverEntry {
  id: string;
  group: ComabooksCoverGroup;
  palette: string;
  name: string;
  preview: string;
  thumb: string;
}

export const comabooksCovers: ComabooksCoverEntry[] = [
  { id: 'cb-1-black', group: 1, palette: 'black', name: 'Дизайн 1 · чёрный', preview: g1black, thumb: g1blackThumb },
  { id: 'cb-1-blue', group: 1, palette: 'blue', name: 'Дизайн 1 · синий', preview: g1blue, thumb: g1blueThumb },
  { id: 'cb-1-green', group: 1, palette: 'green', name: 'Дизайн 1 · тёмно-зелёный', preview: g1green, thumb: g1greenThumb },
  { id: 'cb-1-lightgreen', group: 1, palette: 'lightgreen', name: 'Дизайн 1 · светло-зелёный', preview: g1lightgreen, thumb: g1lightgreenThumb },
  { id: 'cb-1-red', group: 1, palette: 'red', name: 'Дизайн 1 · бордовый', preview: g1red, thumb: g1redThumb },
  { id: 'cb-1-brown', group: 1, palette: 'brown', name: 'Дизайн 1 · жёлтый', preview: g1brown, thumb: g1brownThumb },
  { id: 'cb-2-black', group: 2, palette: 'black', name: 'Дизайн 2 · чёрный', preview: g2black, thumb: g2blackThumb },
  { id: 'cb-2-blue', group: 2, palette: 'blue', name: 'Дизайн 2 · синий', preview: g2blue, thumb: g2blueThumb },
  { id: 'cb-2-green', group: 2, palette: 'green', name: 'Дизайн 2 · тёмно-зелёный', preview: g2green, thumb: g2greenThumb },
  { id: 'cb-2-lightgreen', group: 2, palette: 'lightgreen', name: 'Дизайн 2 · светло-зелёный', preview: g2lightgreen, thumb: g2lightgreenThumb },
  { id: 'cb-2-red', group: 2, palette: 'red', name: 'Дизайн 2 · бордовый', preview: g2red, thumb: g2redThumb },
  { id: 'cb-2-brown', group: 2, palette: 'brown', name: 'Дизайн 2 · жёлтый', preview: g2brown, thumb: g2brownThumb },
  { id: 'cb-3-black', group: 3, palette: 'black', name: 'Дизайн 3 · чёрный', preview: g3black, thumb: g3blackThumb },
  { id: 'cb-3-blue', group: 3, palette: 'blue', name: 'Дизайн 3 · синий', preview: g3blue, thumb: g3blueThumb },
  { id: 'cb-3-green', group: 3, palette: 'green', name: 'Дизайн 3 · тёмно-зелёный', preview: g3green, thumb: g3greenThumb },
  { id: 'cb-3-lightgreen', group: 3, palette: 'lightgreen', name: 'Дизайн 3 · светло-зелёный', preview: g3lightgreen, thumb: g3lightgreenThumb },
  { id: 'cb-3-red', group: 3, palette: 'red', name: 'Дизайн 3 · бордовый', preview: g3red, thumb: g3redThumb },
  { id: 'cb-3-brown', group: 3, palette: 'brown', name: 'Дизайн 3 · жёлтый', preview: g3brown, thumb: g3brownThumb },
  { id: 'cb-4-black', group: 4, palette: 'black', name: 'Дизайн 4 · чёрный', preview: g4black, thumb: g4blackThumb },
  { id: 'cb-4-blue', group: 4, palette: 'blue', name: 'Дизайн 4 · синий', preview: g4blue, thumb: g4blueThumb },
  { id: 'cb-4-green', group: 4, palette: 'green', name: 'Дизайн 4 · тёмно-зелёный', preview: g4green, thumb: g4greenThumb },
  { id: 'cb-4-lightgreen', group: 4, palette: 'lightgreen', name: 'Дизайн 4 · светло-зелёный', preview: g4lightgreen, thumb: g4lightgreenThumb },
  { id: 'cb-4-red', group: 4, palette: 'red', name: 'Дизайн 4 · бордовый', preview: g4red, thumb: g4redThumb },
  { id: 'cb-4-brown', group: 4, palette: 'brown', name: 'Дизайн 4 · жёлтый', preview: g4brown, thumb: g4brownThumb },
];

/** Дефолт старого клиента: группа 1, красный. */
export const COMABOOKS_DEFAULT_COVER_ID = 'cb-1-red';

export const isComabooksCoverId = (v: string | null | undefined): boolean =>
  !!v && comabooksCovers.some((c) => c.id === v);

export const comabooksCoverById = (id: string | null | undefined): ComabooksCoverEntry =>
  comabooksCovers.find((c) => c.id === id) ??
  comabooksCovers.find((c) => c.id === COMABOOKS_DEFAULT_COVER_ID)!;
